import { Action } from "../actions/types";
import { AuthUserType, AuthUserActionList } from "../actions/authUserActions";

const initialValue: AuthUserType = {
  emailId: "",
  mobileNumber: "",
  name: "",
  role: "",
  employeeId: "",
  token: undefined,
  status: undefined,
  photoUrl: "",
};

const authUserReducer = (
  state: AuthUserType = initialValue,
  action: Action,
): AuthUserType => {
  switch (action.type) {
    case AuthUserActionList.SIGNUP_USER:
      return action.data;

    case AuthUserActionList.LOGIN_USER:
      return action.data;

    case AuthUserActionList.LOGOUT_USER:
      return initialValue;
    default:
      return state;
  }
};

export default authUserReducer;
